export const staggerChildrenAnimation = {
    visible: {
        transition: { staggerChildren: 0.1 },
    },
    hidden: {
        transition: { staggerChildren: 0.1, staggerDirection: -1 },
    },
};
export const fallingAnimation = {
    hidden: {
        y: -50,
        opacity: 0,
        transition: {
            y: { stiffness: 1000 },
        },
    },
    visible: {
        y: 0,
        opacity: 1,
        transition: {
            y: { stiffness: 1000, velocity: -100 },
        },
    },
};
//# sourceMappingURL=animations.js.map